module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/BrandFleetwood-79082e33a69eef7f1d958f647ddc5cd0.svg";